<ng-container *ngIf="participant$ | async as participant">
  <div [ngSwitch]="view$ | async">
    <div *ngSwitchCase="'list'">
      <app-participant-action-accompagnement-table></app-participant-action-accompagnement-table>
    </div>
    <div *ngSwitchDefault></div>
  </div>
</ng-container>
